import React from 'react';
import { CtaButton } from './CtaButton';
import { AUTHOR_IMAGE } from '../data/content';
export function Author() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-18" data-mp="oil2renb2ase">
      <div className="mx-auto max-w-3xl" data-id="element-19" data-mp="9tf3jqogwkki">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-brand-600" data-id="element-20" data-mp="9uqau0h4gagd">
          🩺 Chi è la Dott.ssa Karito
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-21" data-mp="12h15yvlylj5s">
          Un messaggio della Dott.ssa Karito
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border border-brand-100 bg-white" data-id="element-22" data-mp="sjwk6ww0zppi">
          <img src={AUTHOR_IMAGE} alt="Ritratto della Dott.ssa Karito in camice bianco nel suo studio medico" className="h-72 w-full object-cover object-top sm:h-96" loading="lazy" data-id="element-23" data-mp="xi7vlc1yy89u" />
          <div className="space-y-4 p-5 sm:p-8" data-id="element-24" data-mp="3i9i1v5towww6">
            <p className="text-[15px] font-medium leading-relaxed text-inksoft sm:text-base" data-id="element-25" data-mp="1tykadgcg6x8a">
              Per anni ho visto molti medici affrontare lo stesso problema:{' '}
              <strong className="font-bold text-ink" data-id="element-26" data-mp="1p1k3j37rxqg4">non mancava loro la conoscenza</strong>.
              Mancava uno strumento pratico che permettesse di trasformare quella conoscenza in un
              processo chiaro, organizzato e facilmente consultabile durante la visita.
            </p>
            <p className="text-[15px] font-medium leading-relaxed text-inksoft sm:text-base" data-id="element-27" data-mp="2cvbnt95b6i4f">
              Le linee guida internazionali sono fondamentali, ma raramente sono progettate per
              rispondere rapidamente alle domande che emergono davanti a un paziente reale.
            </p>
            <p className="text-[15px] font-medium leading-relaxed text-inksoft sm:text-base" data-id="element-28" data-mp="2hoxzoz3nehz6">
              Per questo ho creato il Kit Clinico per la Gestione dell’Obesità: un unico Percorso
              Clinico che riunisce gli strumenti che avrei voluto avere quando ho iniziato a gestire
              pazienti con obesità.
            </p>
            <p className="font-display text-[19px] font-bold leading-snug text-brand-600 sm:text-xl" data-id="element-29" data-mp="1scibcvfx1oka">
              Meno tempo passato a cercare informazioni e più tempo dedicato a prendere decisioni
              cliniche.
            </p>
            <div className="flex items-center gap-3 border-t border-brand-100 pt-5" data-id="element-30" data-mp="224e8a369n8mx">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-brand-500 font-display text-lg font-bold text-white" data-id="element-31" data-mp="2714msm2f9w68">
                K
              </span>
              <span data-id="element-32" data-mp="2g2cn19oi172y">
                <span className="block text-[14px] font-bold leading-tight text-ink" data-id="element-33" data-mp="2g3vzsqay4zzz">
                  Dott.ssa Karito
                </span>
                <span className="block text-[12px] font-medium leading-tight text-inksoft" data-id="element-34" data-mp="lol41jka5auu">
                  Metodologia utilizzata da +2.000 medici
                </span>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10" data-id="element-35" data-mp="j56w2nt6dk53">
          <CtaButton label="Voglio seguire il suo Percorso Clinico" note="Metodologia utilizzata da +2.000 medici" data-id="element-36" data-mp="j5gcpksbyey4" />
        </div>
      </div>
    </section>;
}